import { get, post, put, patch, del, upload, uploadPut } from './client';

export const deliveryCompanyApi = {
  // ── Company CRUD ──
  getAll: (params?: { search?: string; isActive?: boolean }) =>
    get('/delivery-companies', { params }),

  getById: (id: string) =>
    get(`/delivery-companies/${id}`),

  create: (data: { name: string; commissionPercentage: number; discountPercentage?: number; notes?: string; logo?: File | null }) => {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('commissionPercentage', data.commissionPercentage.toString());
    if (data.discountPercentage !== undefined) formData.append('discountPercentage', data.discountPercentage.toString());
    if (data.notes) formData.append('notes', data.notes);
    if (data.logo) formData.append('logo', data.logo);
    return upload('/delivery-companies', formData);
  },

  update: (id: string, data: { name?: string; commissionPercentage?: number; discountPercentage?: number; notes?: string; isActive?: boolean; logo?: File | null }) => {
    const formData = new FormData();
    if (data.name !== undefined) formData.append('name', data.name);
    if (data.commissionPercentage !== undefined) formData.append('commissionPercentage', data.commissionPercentage.toString());
    if (data.discountPercentage !== undefined) formData.append('discountPercentage', data.discountPercentage.toString());
    if (data.notes !== undefined) formData.append('notes', data.notes || '');
    if (data.isActive !== undefined) formData.append('isActive', data.isActive.toString());
    if (data.logo !== undefined) {
      if (data.logo === null) {
        formData.append('logo', 'null');
      } else {
        formData.append('logo', data.logo);
      }
    }
    return uploadPut(`/delivery-companies/${id}`, formData);
  },

  toggleActive: (id: string) =>
    patch(`/delivery-companies/${id}/toggle`),

  delete: (id: string) =>
    del(`/delivery-companies/${id}`),

  // ── Orders ──
  getOrders: (params?: {
    page?: number;
    limit?: number;
    deliveryCompanyId?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
    search?: string;
    sortBy?: string;
    sortOrder?: string;
  }) => get('/delivery-companies/orders', { params }),

  createOrder: (data: {
    deliveryCompanyId: string;
    externalOrderNumber?: string;
    description?: string;
    grossAmount: number;
    notes?: string;
  }) => post('/delivery-companies/orders', data),

  getOrderById: (orderId: string) =>
    get(`/delivery-companies/orders/${orderId}`),

  updateOrderStatus: (orderId: string, status: string) =>
    put(`/delivery-companies/orders/${orderId}/status`, { status }),

  cancelOrder: (orderId: string) =>
    del(`/delivery-companies/orders/${orderId}`),

  // ── Reports ──
  getReport: (params?: { startDate?: string; endDate?: string; deliveryCompanyId?: string }) =>
    get('/delivery-companies/reports/summary', { params }),

  // ── Settlements ──
  getSettlements: (params?: {
    page?: number;
    limit?: number;
    deliveryCompanyId?: string;
    startDate?: string;
    endDate?: string;
  }) => get('/delivery-companies/settlements', { params }),

  createSettlement: (data: {
    deliveryCompanyId: string;
    amount: number;
    date: string;
    notes?: string;
  }) => post('/delivery-companies/settlements', data),

  deleteSettlement: (id: string) =>
    del(`/delivery-companies/settlements/${id}`),
};
